"use strict";

exports.__esModule = true;
exports["default"] = createHocName;

var _getDisplayName = _interopRequireDefault(require("./get-display-name"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createHocName(hocComponentName, WrappedComponent) {
  return hocComponentName + "(" + (0, _getDisplayName["default"])(WrappedComponent) + ")";
}